var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-step",class:_vm.progressStepCssClass},[_c('div',{staticClass:"progress-step__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"progress-step__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]),_c('div',{staticClass:"progress-step__percent"},[_c('ProgressBar',{attrs:{"value":_vm.validatePercent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }